import { StreamId } from "@common/domain";
import { createAction, props } from "@ngrx/store";
import {
  RoomStreamToSubscribeVO,
  RoomStreamToSubscribeVORaw,
  RoomStreamUpdateEventVO
} from "@youm-front/room/domain";

export const remoteRoomStream = createAction(
  "[Room/Events] Remote Room Stream",
  props<{ roomStreamToSubscribeVO: RoomStreamToSubscribeVO }>()
);
export const roomStreamUpdate = createAction(
  "[Room/Events] Room Stream Update",
  props<{ roomStreamUpdateEventVO: RoomStreamUpdateEventVO }>()
);
// Converge the remote room streams to the authoritative stream list (other
// room contexts only), except the streams in `skipStreamIds`: a room stream
// event was received for them while the list was requested, so the list may
// be older than the store for them.
export const remoteRoomStreamsReconcile = createAction(
  "[Room/Events] Remote Room Streams Reconcile",
  props<{
    streams: RoomStreamToSubscribeVORaw[];
    skipStreamIds: StreamId[];
  }>()
);
